const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

const cache = new Map()

class CartUpsells extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.dataset.source === 'metafield') {
      this.carousel = this.setupCarousel()
      this.updateRegiosPrices()

      return
    }

    if (!this.dataset.url || this.dataset.url.includes('product_id=&')) return

    if (cache.has(this.productId)) {
      this.innerHTML = cache.get(this.productId)
      this.carousel = this.setupCarousel()
      this.updateRegiosPrices()

      return
    }

    this.innerHTML = ''

    fetch(this.dataset.url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Recommendations request failed with status ${response.status}`,
          )
        }

        return response.text()
      })
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text

        const recommendations = html.querySelector('cart-upsells')

        if (!recommendations?.innerHTML.trim().length) return

        this.innerHTML = recommendations.innerHTML

        cache.set(this.productId, recommendations.innerHTML)

        document.dispatchEvent(new CustomEvent('reccsAdded'))

        this.carousel = this.setupCarousel()
        this.updateRegiosPrices()
      })
      .catch((error) => {
        console.error('[CartUpsells] Could not load recommendations', error)
      })
  }

  async updateRegiosPrices () {
    const dataElement = this.querySelector(
      '[data-cart-upsells-el="regios-products"]',
    )

    if (!dataElement) return

    let products

    try {
      products = JSON.parse(dataElement.textContent)
    } catch (error) {
      console.warn('[CartUpsells] Could not parse Regios product data', error)

      return
    }

    const api = await this.getRegiosApi()

    if (!api) return

    for (const product of products) {
      const productElement = this.querySelector(
        `[data-regios-dopp-generic-product-id="${product.productId}"]`,
      )

      if (!productElement) continue

      const priceContainer = productElement.querySelector(
        '.regios-dopp-generic-price-container',
      )
      const salePriceElement = productElement.querySelector(
        '.regios-dopp-generic-price-item--sale',
      )
      const regularPriceElement = productElement.querySelector(
        '.regios-dopp-generic-price-item--regular',
      )

      if (!priceContainer || !salePriceElement || !regularPriceElement) {
        continue
      }

      try {
        const { salePrice, regularPrice } =
          await api.calculateDiscountedPrices(product)

        const isDiscounted = salePrice.amount < regularPrice.amount

        this.updatePriceText(salePriceElement, salePrice.formatted)

        if (isDiscounted) {
          this.updatePriceText(regularPriceElement, regularPrice.formatted)

          regularPriceElement.style.removeProperty('display')

          priceContainer.classList.add('regios-dopp-generic-price--on-sale')
        } else {
          this.updatePriceText(salePriceElement, regularPrice.formatted)
          this.updatePriceText(regularPriceElement, '')

          regularPriceElement.style.display = 'none'

          priceContainer.classList.remove('regios-dopp-generic-price--on-sale')
        }
      } catch (error) {
        console.warn(
          `[CartUpsells] Could not calculate Regios price for product ${product.productId}`,
          error,
        )
      }
    }
  }

  updatePriceText (element, value) {
    const screenReaderElement = element.querySelector('.util-ScreenReaderOnly')

    element.replaceChildren()

    if (screenReaderElement) {
      element.append(screenReaderElement)
    }

    element.append(document.createTextNode(value))
  }

  getRegiosApi () {
    if (window.RegiosDOPP?.api?.v0) {
      return Promise.resolve(window.RegiosDOPP.api.v0)
    }

    return new Promise((resolve) => {
      const timeout = window.setTimeout(() => {
        resolve(null)
      }, 5000)

      window.addEventListener(
        'regios-dopp:api-initialized',
        (event) => {
          window.clearTimeout(timeout)

          resolve(event.detail.api)
        },
        { once: true },
      )
    })
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 4,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 4,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }

  get baseUrl () {
    return this.dataset.baseUrl
  }

  get limit () {
    return this.dataset.limit
  }

  get productId () {
    return this.dataset.productId
  }

  get intent () {
    return this.dataset.intent
  }

  get sectionId () {
    return this.dataset.sectionId
  }
}

if (!customElements.get('cart-upsells')) {
  customElements.define('cart-upsells', CartUpsells)
}
